export const GET_APPLICATIONS_REQUEST = 'GET_APPLICATIONS_REQUEST'
export const GET_APPLICATIONS_SUCCESS = 'GET_APPLICATIONS_SUCCESS'
export const GET_APPLICATIONS_FAILURE = 'GET_APPLICATIONS_FAILURE'
export const GET_PROFILE_IFRAME_SOURCE = 'GET_PROFILE_IFRAME_SOURCE'
